export const GOOGLE_WORKSPACE_SURFACES_KEY = "google-workspace-surfaces";

export type GoogleWorkspaceSurfaces = {
  chat: boolean;
  calendar: boolean;
};

export function parseGoogleWorkspaceSurfaces(value: unknown): GoogleWorkspaceSurfaces {
  if (value == null || typeof value !== "object") {
    return { chat: false, calendar: false };
  }
  const record = value as { chat?: unknown; calendar?: unknown };
  return {
    chat: record.chat === true,
    calendar: record.calendar === true,
  };
}
